export { setGalaxyInstance, getGalaxyInstance } from "./singleton";
export { default as galaxyFacade } from "./monitor";
